import React from "react";
import ceramic1 from "../../../assets/childPage/ceramic Main Image.png";
import ceramic2 from "../../../assets/childPage/ceramic Hero Image.png";
import ceramic3 from "../../../assets/childPage/ceramic Benefits Image.png";
import ContactUs from "./ContactUs";
import ScrollTop from "../../ScrollTop";

const Ceramic = () => {
  return (
    <>
    <ScrollTop />
      <div className="bg-gray-300 pb-5">
        <section className="bg-red-600 flex sm:flex-row justify-center items-center gap-8 lg:gap-24 py-6 px-4">
          <img
            src={ceramic1}
            alt="ceramic1"
            loading="lazy"
            className="max-w-48 sm:max-w-sm lg:max-w-lg xl:max-w-4xl 2xl:max-w-6xl  max-h-full object-cover"
          />
          <h4
            style={{ fontFamily: "Ballega" }}
            className="text-white text-xl sm:text-5xl lg:text-6xl text-left"
          >
            Ceramic <br />
            Coating
          </h4>
        </section>

        <section className="flex flex-col justify-center items-center gap-6 mt-4 sm:mt-16">
          <h4
            style={{ fontFamily: "Ballega" }}
            className="text-2xl text-center sm:text-5xl lg:text-6xl"
          >
            What is Ceramic Coating?
          </h4>
          <p
            style={{ fontFamily: "Barlow Condensed" }}
            className="text-base text-start sm:text-center px-4 lg:px-16"
          >
            Ceramic coating is a process that coats a car's surface with a solid
            ceramic material. The benefits of ceramic coating are that it
            protects the car from weathering, corrosion and oxidation. It also
            provides a glossy finish that is tough and resistant to scratches.
          </p>
          <img src={ceramic2} alt="ceramic2" loading="lazy" />
        </section>

        <section className="flex flex-col justify-center- items-center gap-6 mt-4 sm:mt-16 px-4">
          <h4
            style={{ fontFamily: "Ballega" }}
            className="text-2xl text-center sm:text-5xl lg:text-6xl"
          >
            Benefits of Ceramic Coating for Cars
          </h4>
          <p
            style={{ fontFamily: "Barlow Condensed" }}
            className="text-base text-start sm:text-center px-4 lg:px-16"
          >
            The advantages of ceramic coating include a deep gloss, easy
            maintenance and cleaning, resistance to stains and scratches,
            protection from UV rays, temperature regulation, interior
            protection, duration, and an included warranty. Ceramic coating is
            transparent and enhances the reflective properties of your car's
            paint
          </p>
        </section>

        <section
          style={{ fontFamily: "Ballega" }}
          className="text-base lg:flex justify-center items-center mx-4 lg:mx-16 px-4 py-6 mt-4 sm:mt-12 shadow-[-8px_-8px_20px_0px_rgba(0,_0,_0,_0.25)_inset,8px_8px_20px_0px_rgba(0,_0,_0,_0.25)_inset] rounded-xl"
        >
          <div className="lg:w-1/2">
            <h4
              style={{ fontFamily: "Ballega" }}
              className="text-2xl text-center lg:text-start lg:pl-8 lg:text-3xl"
            >
              Benefits of Ceramic Coating for Cars
            </h4>
            <div
              style={{ fontFamily: "Barlow Condensed" }}
              className="text-base px-4 sm:px-16 py-6"
            >
              <ul className="list-disc list-outside pl-6">
                <li className="mb-2">
                  <span className="font-bold">Sleek Look: </span>Ceramic coating
                  is the best for car owners who want to improve the aesthetics
                  of their vehicles. Ceramic coating enhances the depth and
                  gloss of your car's paint. It provides your vehicle with a
                  sleek and glossy look. It brings out the best in your original
                  paint.
                </li>
                <li className="mb-2">
                  <span className="font-bold">No Need for Waxing: </span>Ceramic
                  coating makes a hard layer on the car surface; you don't need
                  waxing and other sealants to preserve shine.
                </li>
                <li className="mb-2">
                  <span className="font-bold">Premium Stain Protection: </span>
                  Ceramic coating protects your car from chemical stains and
                  damage caused by acidic contaminants. It protects chemicals
                  from bonding to your vehicle.
                </li>
                <li className="mb-2">
                  <span className="font-bold">UV Protection: </span>UV rays can
                  damage your vehicle's interior and exterior. Ceramic coating
                  protects the paint from oxidizing and prevents fading of
                  upholstery and interior.
                </li>
                <li className="mb-2">
                  <span className="font-bold">Ease of Cleaning: </span>A hard
                  layer of ceramic car coating makes your vehicle cleaning and
                  maintenance easy. It blends with your car paint and repels
                  water-based dirt, and grime will bead off from the car
                  surface.
                </li>
                <li className="mb-2">
                  <span className="font-bold">Enhanced Aesthetics: </span>
                  Ceramic coating protects your vehicle from water stains. Even
                  rainwater contains natural minerals and other particles that
                  stay on the surface after water dries up. Get rid of water
                  spots with this coating.
                </li>
              </ul>
            </div>
          </div>
          <img src={ceramic3} alt="ceramic3" className="w-full lg:w-1/2" loading="lazy" />
        </section>
        
        <ContactUs />
      </div>
    </>
  );
};

export default Ceramic;
